"use client"

import { useTranslation } from "react-i18next"

const AddAnotherReturnModal = ({ isOpen, onAddAnother, onReturnToMain, userTypeColor = "#8548A8" }) => {
  const { t } = useTranslation();
  
  if (!isOpen) return null

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
        fontFamily: '"Red Hat Display", sans-serif',
      }}
    >
      <style>
        {`
      @keyframes confetti-fade-in {
        0% { transform: scale(0) rotate(0deg); opacity: 0; }
        100% { transform: scale(1) rotate(360deg); opacity: 1; }
      }
      .confetti-star {
        animation: confetti-fade-in 1.2s ease-out forwards; /* Lengthened animation */
      }
      .confetti-square {
        animation: confetti-fade-in 1.2s ease-out forwards; /* Lengthened animation */
      }
      `}
      </style>
      <div
        style={{
          background: "#FFFFFF",
          borderRadius: "20px",
          padding: "40px",
          width: "100%",
          maxWidth: "560px", // Widened modal
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "24px",
        }}
      >
        {/* Success Icon with Confetti */}
        <div
          style={{
            width: "100px",
            height: "100px",
            borderRadius: "50%",
            background: "#D1FAE5", // Light green background
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "16px",
            position: "relative",
            overflow: "hidden", // Ensure confetti stays within bounds
          }}
        >
          {/* Updated Checkmark SVG */}
          <svg
            width="50"
            height="50"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ zIndex: 1 }}
          >
            <path
              d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z"
              fill="#10B981" // Green checkmark color
            />
          </svg>
          {/* Confetti elements */}
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Yellow Stars */}
            <svg
              className="confetti-star"
              style={{
                position: "absolute",
                width: "12px",
                height: "12px",
                top: "5%",
                left: "20%",
                opacity: 0,
                animationDelay: "0.1s",
              }}
              viewBox="0 0 24 24"
              fill="#FBBF24"
            >
              <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.62L12 2L9.19 8.62L2 9.24L7.46 13.97L5.82 21L12 17.27Z" />
            </svg>
            <svg
              className="confetti-star"
              style={{
                position: "absolute",
                width: "10px",
                height: "10px",
                bottom: "10%",
                right: "15%",
                opacity: 0,
                animationDelay: "0.3s",
              }}
              viewBox="0 0 24 24"
              fill="#FBBF24"
            >
              <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.62L12 2L9.19 8.62L2 9.24L7.46 13.97L5.82 21L12 17.27Z" />
            </svg>
            <svg
              className="confetti-star"
              style={{
                position: "absolute",
                width: "8px",
                height: "8px",
                top: "30%",
                right: "5%",
                opacity: 0,
                animationDelay: "0.5s",
              }}
              viewBox="0 0 24 24"
              fill="#FBBF24"
            >
              <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.62L12 2L9.19 8.62L2 9.24L7.46 13.97L5.82 21L12 17.27Z" />
            </svg>

            {/* Light Blue Squares */}
            <div
              className="confetti-square"
              style={{
                position: "absolute",
                width: "10px",
                height: "10px",
                background: "#BFDBFE", // Light blue
                borderRadius: "2px",
                top: "15%",
                right: "25%",
                opacity: 0,
                animationDelay: "0.2s",
              }}
            ></div>
            <div
              className="confetti-square"
              style={{
                position: "absolute",
                width: "8px",
                height: "8px",
                background: "#BFDBFE", // Light blue
                borderRadius: "2px",
                bottom: "20%",
                left: "5%",
                opacity: 0,
                animationDelay: "0.4s",
              }}
            ></div>

            {/* Light Green Squares */}
            <div
              className="confetti-square"
              style={{
                position: "absolute",
                width: "10px",
                height: "10px",
                background: "#A7F3D0", // Light green
                borderRadius: "2px",
                top: "25%",
                left: "5%",
                opacity: 0,
                animationDelay: "0.3s",
              }}
            ></div>
            <div
              className="confetti-square"
              style={{
                position: "absolute",
                width: "8px",
                height: "8px",
                background: "#A7F3D0", // Light green
                borderRadius: "2px",
                bottom: "5%",
                left: "30%",
                opacity: 0,
                animationDelay: "0.5s",
              }}
            ></div>
          </div>
        </div>

        <h2
          style={{
            fontSize: "28px",
            fontWeight: 600,
            color: "#1F2937",
            margin: 0,
          }}
        >
          {t("addPet.successModal.title")}
        </h2>
        <p
          style={{
            fontSize: "16px",
            color: "#494949", // Updated color
            margin: 0,
            lineHeight: "1.5",
          }}
        >
          {t("addPet.successModal.message")}
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            width: "100%",
            marginTop: "20px",
          }}
        >
          <button
            onClick={onAddAnother}
            style={{
              width: "100%",
              height: "56px",
              background: userTypeColor,
              color: "#FFFFFF",
              border: "none",
              borderRadius: "14px",
              fontFamily: '"Red Hat Display", sans-serif',
              fontSize: "18px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s ease",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
            onMouseEnter={(e) => {
              // Calculate darker shade for hover
              const hoverColor = userTypeColor === "#8548A8" ? "#7A4397" : 
                                 userTypeColor === "#00D4B3" ? "#00C4A7" :
                                 userTypeColor === "#D65745" ? "#C7493A" :
                                 userTypeColor === "#2A8AD2" ? "#2596BE" : userTypeColor;
              e.target.style.background = hoverColor;
              e.target.style.transform = "translateY(-1px)"
              e.target.style.boxShadow = "0 6px 20px rgba(0,0,0,0.15)"
            }}
            onMouseLeave={(e) => {
              e.target.style.background = userTypeColor;
              e.target.style.transform = "translateY(0)"
              e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)"
            }}
          >
            {t("addPet.successModal.addAnotherButton")}
          </button>
          <button
            onClick={onReturnToMain}
            style={{
              width: "100%",
              height: "56px",
              background: "#FFFFFF",
              color: "#303E4E", // Updated color
              border: "2px solid #49494966", // Updated border
              borderRadius: "14px",
              fontFamily: '"Red Hat Display", sans-serif',
              fontSize: "18px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              // Use user type color for hover border and text
              const hoverBg = userTypeColor === "#8548A8" ? "#F8F4FF" : 
                              userTypeColor === "#00D4B3" ? "#E0F7F4" :
                              userTypeColor === "#D65745" ? "#FEF2F2" :
                              userTypeColor === "#2A8AD2" ? "#EFF6FF" : "#F8F4FF";
              e.target.style.background = hoverBg;
              e.target.style.borderColor = userTypeColor;
              e.target.style.color = userTypeColor;
              e.target.style.transform = "translateY(-1px)"
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "#FFFFFF"
              e.target.style.borderColor = "#49494966"
              e.target.style.color = "#303E4E"
              e.target.style.transform = "translateY(0)"
            }}
          >
            {t("addPet.successModal.returnButton")}
          </button>
        </div>
      </div>
    </div>
  )
}

export default AddAnotherReturnModal
